// Import model
import { NoteCondition } from '../models/NoteCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { NoteIndexedFields } from '../models/NoteIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { NoteIndexedFieldsSerializer } from './NoteIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for NoteCondition - handles JSON serialization and deserialization with type validation
 */
export class NoteConditionSerializer {
  /**
   * Deserializes a JSON string into a NoteCondition instance
   */
  static deserialize(json: string): NoteCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a NoteCondition instance
   */
  static fromObject(obj: any): NoteCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to NoteCondition');
    }


    const instance: NoteCondition = {
      fieldName: obj['fieldName'] as NoteIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of NoteCondition instances
   */
  static deserializeArray(json: string): NoteCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a NoteCondition instance to a JSON string
   */
  static serialize(instance: NoteCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a NoteCondition instance to a plain object
   */
  static toObject(instance: NoteCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of NoteCondition instances to a JSON string
   */
  static serializeArray(instances: NoteCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
